export default {
	footer: {
		impressum: 'Impressum'
	}
}
